import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const SubscriptionList = lazy(
    () => import('../components/SubscriptionListContainer')
)

const SubscriptionRoute: RouteObject = {
    path: 'subscriptions',
    element: <SubscriptionList />,
}

export { SubscriptionRoute }
